import { CheckMark, DeprecatedCheckIcon, LineIcon, theme } from '@arnold/common';
import styled from '@emotion/styled';
import { useEffect, useRef } from 'react';

interface CheckboxRowProps {
  selected: boolean;
  partlySelected?: boolean;
  label: React.ReactNode;
  onClick: () => void;
  level?: number;
  disabled?: boolean;
  isStatement?: boolean;
}

export const CheckboxRow = ({
  selected,
  partlySelected,
  label,
  onClick,
  level = 0,
  disabled,
  isStatement,
}: CheckboxRowProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = !!partlySelected && !selected;
    }
  }, [partlySelected, selected]);

  return (
    <RowContainer level={level} disabled={disabled}>
      <Label isStatement={isStatement}>
        {label}
        <Input
          ref={inputRef}
          type="checkbox"
          checked={selected}
          disabled={disabled}
          onChange={() => {
            if (!disabled) {
              onClick();
            }
          }}
        />
        <CheckMark
          className="inline-checkbox"
          selected={selected}
          disabled={disabled}
          checkMarkStyles="top:10px !important; left: 4px !important; pointer-events: none;"
        >
          {selected ? <DeprecatedCheckIcon /> : partlySelected && <LineIcon />}
        </CheckMark>
      </Label>
    </RowContainer>
  );
};

const RowContainer = styled.div<{ level: number; disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  background: ${theme.colors.backgroundCover.default};
  transition: background 0.15s ease;

  &:hover {
    background: ${({ disabled }) =>
      disabled ? theme.colors.backgroundCover.default : theme.colors.backgroundBasic.default};
  }

  &:hover .inline-checkbox {
    border-color: ${({ disabled }) => (disabled ? theme.colors.borderMain.disabled : theme.colors.borderMain.focused)};
  }
`;

const Label = styled.label<{ isStatement?: boolean }>`
  display: block;
  position: relative;
  cursor: inherit;
  user-select: none;
  margin-top: 1px;
  margin-bottom: 0px;
  padding: 8px;
  padding-left: 32px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  & input:focus-visible + span {
    box-shadow: 0px 0px 6px ${theme.colors.borderMain.focused};
  }
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: inherit;
  height: 18px;
  width: 18px;
  top: 10px;
  left: 4px;
  margin: 0;
`;
